import Image from 'next/image';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslations } from 'next-intl';
import styles from './Popup.module.scss';
export interface PopupProps {
  show: boolean;
  handleClose: () => void;
  appButtons: {
    appLink: string;
    event: string;
    alt: string;
    colorButtonImage: Record<string, string>;
  }[];
  moveToExternalLink: (appLink: string, event: string, target: '_blank') => void;
  language: string;
}
export const Popup: FC<PopupProps> = ({
  show,
  handleClose,
  appButtons = [],
  moveToExternalLink,
  language
}) => {
  const t = useTranslations();
  const translatedHtml = t('app_popup');
  return <Modal show={show} onHide={handleClose} size="lg" data-sentry-element="Modal" data-sentry-component="Popup" data-sentry-source-file="Popup.tsx">
            <Modal.Body className={styles.modalBody} data-sentry-element="unknown" data-sentry-source-file="Popup.tsx">
                <div className="icon-holder">
                    <Image src="https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/icons/squre-close.svg" width={20} height={20} loading="lazy" onClick={handleClose} alt={'Close'} data-sentry-element="Image" data-sentry-source-file="Popup.tsx" />
                </div>
                <div className={`row ${styles.row}`}>
                    <div className={`col-6 d-flex justify-content-center ${styles.img}`}>
                        <img src="https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/home_img/popup_asset.webp" className="p-5" />
                    </div>
                    <div className="col-6 d-flex flex-column justify-content-center">
                        <h3>
                            <span>{t('app_popup')}</span>
                            <br></br>
                            {t('GetThingsDone')}
                        </h3>
                        <img src="https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/home_img/qr-code.png" className={`${styles.QR} py-3`} loading="lazy" />

                        <div className={`${styles.app} pt-3 d-flex link`}>
                            {appButtons.map((appButton, index) => <div key={index} onClick={() => {
              moveToExternalLink(appButton.appLink, appButton.event, '_blank');
            }}>
                                    <Image src={appButton.colorButtonImage[language] || appButton.colorButtonImage['en']} width={130} height={40} alt={'appButton.alt'} loading="lazy" />
                                </div>)}
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>;
};